/** @format */

import Cookies from "./../library/Cookies";
import Forms from "./Forms";

export default class Popups {
	constructor() {
		this.instance = self;
		this.formsInstance = new Forms();
		this.popupOptions = {
			removalDelay: 500,
			closeOnBgClick: false,
			mainClass: "mfp-slide-out",
			callbacks: {
				open: function () {
					$("body").addClass("popup-open");
				},
				ajaxContentAdded: function () {
					Forms.setResolutionInputs();
					window.site.lazyLoad(".popup [data-lazy-svg]");
					self.formsInstance.attachSelectPlugin($(".popup .js-select2"));
					self.formsInstance.attachSliders($(".popup .js-slider"));
					self.formsInstance.attachRangeSliders($(".popup .js-range-slider"));
					self.formsInstance.attachDatePickerPlugin($(".popup .js-datepicker"));
					self.formsInstance.attachTimePickerPlugin($(".popup .js-timepicker"));

					$(".js-adaptive-placeholder").each(function () {
						self.formsInstance.checkAdaptivePlaceholder($(this));
					});
				},
				close: function () {
					$("body").removeClass("popup-open");
				},
			},
		};
	}

	static init() {
		const self = new Popups();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.addEmailPopupButtonClass();

		let urlHash = window.location.hash;

		if (urlHash.indexOf("#popup-") !== -1) {
			let urlHashParts = urlHash.split("#popup-"),
				popupUrl = urlHashParts[1];

			self.openAjaxPopup(popupUrl);
		}

		window.site.openAjaxPopup = function (url) {
			self.openAjaxPopup(url);
		};

		window.site.openAjaxBottomPopup = function (url) {
			self.openAjaxBottomPopup(url);
		};

		// ensure popupUrl isn't set on page load as we have no popup open
		Cookies.deleteCookie("popupUrl");

		let openPopupUrl = Cookies.getCookie("openPopup");
		if (openPopupUrl != null) {
			self.openAjaxPopup(decodeURIComponent(openPopupUrl));
		}

		$(document).on("click", ".js-popup", function (e) {
			e.preventDefault();
			self.openAjaxPopup($(this).attr("href"));
		});

		$(document).on("click", ".js-popup-inline", function (e) {
			e.preventDefault();
			self.openInlinePopup($(this).attr("href"));
		});

		// prevent default to stop # from being appended to url
		$(document).on("click", ".js-close-popup", function (e) {
			e.preventDefault();
			$.magnificPopup.instance.close();
		});

		$(document).on("mousedown", ".mfp-container", function (e) {
			$.magnificPopup.instance.close();
		});

		$(document).on("mousedown", ".popup, .mfp-figure, .mfp-prevent-close", function (e) {
			e.stopPropagation();
		});

		$(".js-gallery-popup").each(function () {
			self.openGalleryPopup($(this), ".js-gallery-popup-link");
		});

		if ($(".js-trigger-popup-on-load").length > 0) {
			var popupCookie = Cookies.getCookie("popup-window");
			if (popupCookie != "accepted") {
				setTimeout(function () {
					if (!$("body").hasClass("popup-open")) {
						$(".js-trigger-popup-on-load").trigger("click");
					}
				}, 3000);
			}
		}

		$(document).on("click", ".mfp-slide-up", function (e) {
			// If popup window closed
			if ($(this).hasClass("mfp-removing")) {
				Cookies.setCookie("popup-window", "accepted", 60);
			}
		});

		$(document).on("click", ".popup-window .js-close-popup", function (e) {
			Cookies.setCookie("popup-window", "accepted", 60);
		});
	}

	addEmailPopupButtonClass() {
		$(".email-pop-up-class").each(function () {
			$(this)
				.closest("form")
				.find('button[type="submit"]')
				.addClass("text-larger");
		});
	}

	openAjaxPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			mainClass: "mfp-slide-out",
		});
	}

	openAjaxCentralPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			mainClass: "mfp-zoom-out",
		});
	}

	openAjaxBottomPopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			mainClass: "mfp-slide-up",
		});
	}

	openInlinePopup(id) {
		const self = this;

		self.openPopup({
			items: { src: id },
			type: "inline",
			mainClass: "mfp-slide-out",
		});
	}

	openPopup(options) {
		const self = this;

		var magnificPopup = $.magnificPopup.instance,
			defaultOptions = self.popupOptions,
			popupOptions = Object.assign(defaultOptions, options);

		// Different animation for popup window
		if (options.items.src.indexOf("/popup-timed") >= 0) {
			popupOptions.mainClass = "mfp-slide-up";
		}

		if (popupOptions.type == "ajax") {
			popupOptions.callbacks.ajaxContentAdded = function () {
				Forms.setResolutionInputs();
				window.site.lazyLoad(".popup [data-lazy-svg]");
				self.formsInstance.attachSelectPlugin($(".popup .js-select2"));
				self.formsInstance.attachSliders($(".popup .js-slider"));
				self.formsInstance.attachRangeSliders($(".popup .js-range-slider"));
				self.formsInstance.attachDatePickerPlugin($(".popup .js-datepicker"));
				self.formsInstance.attachTimePickerPlugin($(".popup .js-timepicker"));

				$(".js-adaptive-placeholder").each(function () {
					self.formsInstance.checkAdaptivePlaceholder($(this));
				});

				self.addEmailPopupButtonClass();

				Cookies.deleteCookie("openPopup");

				Cookies.setCookie("popupUrl", popupOptions.items.src, 1);
				$(document).trigger("popupOpen", popupOptions.items.src);

				if (options.items.src.indexOf("/popup-timed") >= 0) {
					setTimeout(function () {
						$(".popup-window .form-check-input").prop("checked", true);
						$(".popup-window form").attr(
							"data-success-script",
							'$(".popup-window .js-close-popup").trigger("click");'
						);
					}, 1000);
				}
			};

			popupOptions.callbacks.close = function () {
				$("body").removeClass("popup-open");
				Cookies.deleteCookie("popupUrl");
			};
		} else if (popupOptions.type == "inline") {
			popupOptions.callbacks.elementParse = function (item) {
				$(document).trigger("popupOpen", popupOptions.items.src);
			};
		}

		if (magnificPopup.isOpen == true) {
			magnificPopup.close();

			setTimeout(function () {
				$.magnificPopup.open(popupOptions);
			}, 500);
		} else {
			$.magnificPopup.open(popupOptions);
		}
	}

	openGalleryPopup($element, selector) {
		$element.magnificPopup({
			type: "image",
			delegate: selector,
			mainClass: "mfp-zoom-out",
			gallery: {
				enabled: true,
			},
			callbacks: {
				buildControls: function () {
					if (this.arrowLeft) this.arrowLeft.appendTo(this.contentContainer);
					if (this.arrowRight) this.arrowRight.appendTo(this.contentContainer);
				},
			},
		});
	}
}
